import React from "react";
import { withRouter } from "react-router-dom";

import ProposalsPieView from "./proposals-stats-view";


export default withRouter(function (props) {
let {user, projects, currentYear, year, title, type} = props

 
  return (
    <div>
        <ProposalsPieView
          user={user}
          title={title}
          type={type}
          year={year}
          projects={projects}
          currentYear={currentYear}
        />
    </div>
  );
});
